import { getActiveLanguage } from './homepageUrl';

export function getContentLanguageToken(content, pathname, locale) {
  return (
    content?.language?.token ||
    content?.language?.id ||
    getActiveLanguage(pathname, locale)
  );
}

export function getContentLanguageDisplayCode(content, pathname, locale) {
  const token = getContentLanguageToken(content, pathname, locale);
  return token ? String(token).toUpperCase() : '';
}

export function getContentLanguageHtmlLang(content, pathname, locale) {
  const token = getContentLanguageToken(content, pathname, locale);
  return token ? String(token).toLowerCase() : undefined;
}
